<!-- Reports section-->
<section class="reports-section" [ngClass]="{ 'example-strip': holding.id === EXAMPLE_ASSET_ID }"
         *ngIf="(reportsBasic$ | async).length > 0">
  <!-- Report selector -->
  <div class="terra-form-field-wrapper report-select">
    <span class="title">Reports</span>
    <label for="ddlReportId" class="text-input-label">Select a report</label>
    <mat-form-field appearance="outline" class="remove-error-place">
      <mat-select id="ddlReportId" placeholder="Select" [ngModel]="displayedReportId$.value"
                  (valueChange)="displayedReportId$.next($event)">
        <mat-option *ngFor="let reportListItem of reportsBasic$ | async" [value]="reportListItem.id">
          {{ getReportName(reportListItem) }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>
  <!-- Loader -->
  <ng-template #reportLoading>
    <terra-loader></terra-loader>
  </ng-template>

  <!-- Report -->
  <div id="focusReports">
    <terra-holding-report id="reportsSection" *ngIf="reportDetails$ | async as report; else reportLoading"
                          [report]="report" [holdingCurrency]="holding.initialCurrency" [holdingDiscriminator]="holdingDiscriminator"
                          [isExample]="holding.id === EXAMPLE_ASSET_ID">
    </terra-holding-report>
  </div>
</section>
